import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatDateTime = (value?: string | null) => {
    if (!value) return '-';
    return format(new Date(value), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
};
